<template>
  <div class="folder-modern">
    <NavBar />

    <div class="folder-container">
      <!-- Header Section -->
      <div class="folder-header">
        <div class="header-content">
          <div class="back-button-section">
            <v-btn class="btn-back-modern" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2"></i>
              Voltar
            </v-btn>
          </div>

          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-folder-open title-icon"></i>
              Gestão de Pastas
            </h1>
            <p class="page-subtitle">
              Organize e gerencie documentos por residente de forma eficiente
            </p>
          </div>

          <div v-if="permission('write', 'folder')" class="actions-section">
            <v-btn
              class="btn-add-modern"
              @click="$bvModal.show('createFolder')"
            >
              <i class="fas fa-plus mr-2"></i>
              Nova Pasta
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Filters Section -->
      <div class="filters-section">
        <div class="filters-card">
          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-user-friends filter-icon"></i>
              Filtrar por Residente
            </label>
            <v-select
              v-model="resident_id"
              :items="residents"
              item-text="name"
              item-value="id"
              placeholder="Selecione um residente"
              clearable
              outlined
              @change="getFolders"
            >
              <template v-slot:no-data>
                <div class="no-data-message">
                  <i class="fas fa-info-circle mr-2"></i>
                  Nenhum residente encontrado
                </div>
              </template>
            </v-select>
          </div>
        </div>
      </div>

      <!-- Content Section -->
      <div class="content-section">
        <!-- Public Folders Section -->
        <div class="folders-section">
          <div class="section-header public-header">
            <div class="section-title">
              <i class="fas fa-globe section-icon"></i>
              <span>Pastas Públicas</span>
            </div>
            <div class="section-badge public-badge">
              {{ foldersPublics.length }}
              {{ foldersPublics.length === 1 ? "pasta" : "pastas" }}
            </div>
          </div>
          <div class="folders-container">
            <ListFolder
              :folders="foldersPublics"
              @change="getFolders"
              @noResults="handleNoResults('public', true)"
              @hasResults="handleNoResults('public', false)"
            />
          </div>
        </div>

        <!-- Private Folders Section -->
        <div class="folders-section">
          <div class="section-header private-header">
            <div class="section-title">
              <i class="fas fa-lock section-icon"></i>
              <span>Pastas Privadas</span>
            </div>
            <div class="section-badge private-badge">
              {{ foldersPrivates.length }}
              {{ foldersPrivates.length === 1 ? "pasta" : "pastas" }}
            </div>
          </div>
          <div class="folders-container">
            <ListFolder
              :folders="foldersPrivates"
              @change="getFolders"
              @noResults="handleNoResults('private', true)"
              @hasResults="handleNoResults('private', false)"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Create Folder Modal -->
    <CreateFolder @create="getFolders" />
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ListFolder from "../templates/Folder/ListFolder";
import CreateFolder from "../templates/Folder/CreateFolder";
import api from "../services/api";
import permission from "../lib/permission";
import routes from "../routes";

export default {
  name: "Folder",
  components: {
    NavBar,
    ListFolder,
    CreateFolder,
  },
  data() {
    return {
      folder_id: null,
      foldersPublics: [],
      foldersPrivates: [],
      resident_id: null,
      residents: [],
      noResultsPublic: false,
      noResultsPrivate: false,
      noResults: false,
      loading: false,
    };
  },
  async created() {
    await this.getFolders();
    await this.getResidents();
  },
  methods: {
    permission,
    handleToBack: () => routes.go(-1),

    async getFolders() {
      try {
        this.loading = true;
        const { resident_id } = this;
        let params = { resident_id };

        const response = await api.get("/folder/all", { params });
        const { foldersPublics, foldersPrivates } = response.data;

        this.foldersPublics = foldersPublics;
        this.foldersPrivates = foldersPrivates;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },

    async getResidents() {
      try {
        this.loading = true;
        let params = { status_resident: "ATIVO" };

        const response = await api.get("/rest-home/residents", { params });
        const { error, residents } = response.data;

        if (!error) {
          this.residents = residents;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },

    handleNoResults(type, value) {
      if (type == "public") {
        this.noResultsPublic = value;
      } else if (type == "private") {
        this.noResultsPrivate = value;
      }
      this.noResults = this.noResultsPublic && this.noResultsPrivate;
    },
  },
};
</script>

<style scoped>
.folder-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.folder-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.folder-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

/* Buttons */
.btn-back-modern {
  background: transparent !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  padding: 12px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
}

.btn-back-modern:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.btn-add-modern {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.4) !important;
}

/* Filters Section */
.filters-section {
  margin-bottom: 32px;
}

.filters-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 400px;
}

.filter-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.filter-icon {
  color: #6b7280;
  font-size: 14px;
}

.select-icon {
  color: #9ca3af;
  font-size: 16px;
}

.no-data-message {
  color: #6b7280;
  font-size: 14px;
  padding: 12px;
  text-align: center;
}

/* Content Section */
.content-section {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 32px;
}

/* Folders Sections */
.folders-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.public-header {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
}

.private-header {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 600;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.public-header .section-title {
  color: #065f46;
}

.private-header .section-title {
  color: #92400e;
}

.section-icon {
  font-size: 16px;
}

.public-header .section-icon {
  color: #059669;
}

.private-header .section-icon {
  color: #d97706;
}

.section-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.public-badge {
  background: rgba(16, 185, 129, 0.1);
  color: #059669;
  border: 1px solid #34d399;
}

.private-badge {
  background: rgba(217, 119, 6, 0.1);
  color: #d97706;
  border: 1px solid #f59e0b;
}

.folders-container {
  padding: 24px;
}

/* No Results Section */
.no-results-section {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.no-results-card {
  background: white;
  border-radius: 20px;
  padding: 48px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.no-results-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.no-results-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #94a3b8;
  margin-bottom: 8px;
}

.no-results-title {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.no-results-text {
  font-size: 16px;
  color: #64748b;
  margin: 0;
  line-height: 1.6;
}

.no-results-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}

.btn-create-first {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-create-first:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.4) !important;
}

.btn-clear-filter {
  background: transparent !important;
  color: #6b7280 !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  padding: 12px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
}

.btn-clear-filter:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
  transform: translateY(-1px) !important;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }

  .page-title {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .folder-container {
    padding: 0 16px;
  }

  .folder-header {
    padding: 16px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .filters-card,
  .folders-container {
    padding: 16px;
  }

  .section-header {
    padding: 16px;
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }

  .no-results-card {
    padding: 32px 24px;
  }

  .no-results-icon {
    width: 64px;
    height: 64px;
    font-size: 24px;
  }

  .no-results-title {
    font-size: 20px;
  }

  .no-results-actions {
    flex-direction: column;
    align-items: stretch;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .btn-add-modern,
  .btn-create-first,
  .btn-clear-filter {
    padding: 10px 16px !important;
    font-size: 14px !important;
  }

  .section-title {
    font-size: 16px;
  }

  .no-results-title {
    font-size: 18px;
  }

  .no-results-text {
    font-size: 14px;
  }
}

/* Override Vuetify styles */
.modern-select >>> .v-input__control {
  border-radius: 8px !important;
}

.modern-select >>> .v-text-field__slot input {
  font-weight: 500 !important;
}

.modern-select >>> .v-select__selection {
  color: #374151 !important;
  font-weight: 500 !important;
}

.modern-select >>> .v-input__prepend-inner {
  margin-top: 0 !important;
  padding-right: 8px !important;
}
</style>